import { Box, Tooltip } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

const PAGE_LABELS = {
  1: "Home",
  2: "Services",
  3: "Products",
  4: "Clients",
  5: "Contact us",
  6: "About us",
  7: "What's New",
  8: "Our Team",
};

export const AllMetadata = () => {
  const classes = useAdminStyles();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios.get("/api/getmetadatas", { headers: { headKey: headKey } }).then(
      (res) => {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#metadata_table").DataTable({ destroy: true });
        });
      }
    );
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Metadata - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="SEO"
        title="Page metadata"
        subtitle="Edit per-page meta titles, keywords, and descriptions."
      />

      <Box className={classes.tableWrap}>
        <table
          id="metadata_table"
          className="display"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Page</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.meta_id}>
                <td>{da.meta_id}</td>
                <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                  {da.meta_title}
                </td>
                <td>{PAGE_LABELS[da.meta_page] || "-"}</td>
                <td>
                  <Box className={classes.actionCell}>
                    <Tooltip title="Edit" arrow>
                      <Link
                        to={"/dash/editmetadata/" + da.meta_id}
                        className={classes.iconBtn}
                        aria-label="Edit"
                      >
                        <EditOutlinedIcon />
                      </Link>
                    </Tooltip>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
